export class ServiceResponseModel {


  hasMessage:boolean;
  messageType: string;
  messageHeader:string;
  message: string;
  hasAppException :boolean;
  hasException :boolean;

  data: any;
  statusCode:number;

  appException:any;
  AppException:any;


}
